<template>
  <v-card class="application-item">
    <v-toolbar color="teal darken-4" dark>
      <v-toolbar-side-icon left>{{ application.application_type.acronym }}</v-toolbar-side-icon>
      <v-toolbar-title>{{ application.application_type.name }}</v-toolbar-title>

      <v-spacer/>

      <v-tooltip top>
        <span slot="activator">
          {{ application.sent_at | formatDate }}
        </span>
        <span>Data de envio</span>
      </v-tooltip>
    </v-toolbar>

    <v-list two-line subheader>
      <v-list-tile avatar @click="showApplication(application)">
        <v-list-tile-avatar>
          <v-icon>{{ personalTypeIcon }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ application.person.name }}</v-list-tile-title>
          <v-list-tile-sub-title>
            {{ processCpfCnpj }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-tooltip left v-if="application.locked_by == null">
            <v-list-tile-action-text class="badge amber" slot="activator">
              Em análise
            </v-list-tile-action-text>
            <span>Aguarde, estamos analisando seu requerimento</span>
          </v-tooltip>
          <v-tooltip left v-else>
            <v-list-tile-action-text class="badge amber" slot="activator">
              Análise em Andamento
            </v-list-tile-action-text>
            <span>Análise iniciada por {{application.locked_by.name}} em
              {{application.locked_at | formatTimestamp }}</span>
          </v-tooltip>

        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'ApplicationInReview',
  props: {
    application: {
      default: () => {},
      type: Object,
    },
    personalTypeIcon: {
      type: String,
      default: '',
    },
    processCpfCnpj: {
      type: String,
      default: '',
    },
  },
  methods: {
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  },
};
</script>

